import qs from 'query-string';

import { SEARCH_PARAM, DEFAULT_SORT } from './constants';

export const getDefaultEmptyList = () => ({
  data: [],
  total: 0,
});

const defaultTransformFilter = () => null;

export const getDefaultListHandler = ({
  dataSource,
  url,
  transformFilter = defaultTransformFilter,
  defaultFilters,
}) => async ({ page, perPage, query, sort = DEFAULT_SORT.key, date, email, ...otherFilters } = {}, options = {}) => {
  const response = await dataSource.get(url, {
    ...options,
    searchParams: qs.stringify({
      [SEARCH_PARAM.PAGE_SIZE]: perPage,
      [SEARCH_PARAM.PAGE_NUMBER]: page,
      [SEARCH_PARAM.EMAIL]: email,
      [SEARCH_PARAM.QUERY]: query,
      [SEARCH_PARAM.SORT]: sort,
      [SEARCH_PARAM.DATE]: date,
      ...defaultFilters,
      language: window.localStorage.currentAssetLanguage || 'en', // @TODO Make this a value passed in dynamically
      ...transformFilter(otherFilters),
    }),
  });

  const data = await response.json();
  const total = Number.parseInt(response.headers.get('X-Total-Count'), 10) ?? 0;

  return {
    data,
    total,
  };
};

export const makeGetByIds = ({ dataSource, url }) => ({ ids }) =>
  dataSource.get(url, { searchParams: qs.stringify({ ids }) }).json();

export const transformEventChampionships = (events) => {
  const eventsBySex = events
    ? {
        menEvents: events?.map((item) => item.menEvents),
        womenEvents: events?.map((item) => item.womenEvents),
        mixedEvents: events?.map((item) => item.mixedEvents),
      }
    : {};

  return {
    menEvents: returnUniqueIdObjects(eventsBySex?.menEvents),
    womenEvents: returnUniqueIdObjects(eventsBySex?.womenEvents),
    mixedEvents: returnUniqueIdObjects(eventsBySex?.mixedEvents),
  };
};

export function returnUniqueIdObjects(arr) {
  return [
    ...arr
      ?.flat()
      .reduce((a, c) => {
        a.set(c.id, c);
        return a;
      }, new Map())
      .values(),
  ];
}
